import {Component, ElementRef, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {NgIf} from '@angular/common';
import {IconsaxDirective} from '../../../directives/iconsax.directive';

export enum ButtonStyle {
    Gray,
    Green,
    GreenBack,
    White,
    Blue,
    WhiteBlue
}

@Component({
    selector: 'ui-text-button',
    templateUrl: './text-button.html',
    styleUrls: ['./text-button.scss'],
    imports: [NgIf, IconsaxDirective]
})
export class TextButtonComponent implements OnInit {
    @Input() buttonStyle: ButtonStyle;
    @HostBinding('class.disabled') @Input() disabled = false;
    @HostBinding('class.loading') @Input() loaderShow = false;

    @HostBinding('class.gray')
    get grayClass(): boolean {
        return this.buttonStyle === ButtonStyle.Gray;
    }

    @HostBinding('class.green')
    get greenClass(): boolean {
        return this.buttonStyle === ButtonStyle.Green;
    }

    @HostBinding('class.green-back')
    get greenBackClass(): boolean {
        return this.buttonStyle === ButtonStyle.GreenBack;
    }

    @HostBinding('class.white')
    get greenWhiteClass(): boolean {
        return this.buttonStyle === ButtonStyle.White;
    }

    @HostBinding('class.blue')
    get greenBlueClass(): boolean {
        return this.buttonStyle === ButtonStyle.Blue;
    }

    @HostBinding('class.whiteBlue')
    get whiteBlueClass(): boolean {
        return this.buttonStyle === ButtonStyle.WhiteBlue;
    }

    constructor(private elementRef: ElementRef) {
        this.buttonStyle = ButtonStyle.Gray;
    }

    ngOnInit() {
    }

    @HostListener('keydown.enter', ['$event'])
    onKeyEnter(e: Event) {
        e.stopPropagation();
        if (!this.disabled && !this.loaderShow) {
            this.elementRef.nativeElement.click();
        }
    }
}
